var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"loading":Object.keys(_vm.data).length == 0}},[(Object.keys(_vm.data).length > 0)?_c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex align-center flex-wrap mb-4",staticStyle:{"gap":"16px"}},[(!_vm.data.CESCE)?_c('v-alert',{staticClass:"ma-0",attrs:{"type":"warning","text":""}},[_vm._v("Este cliente no está en CESCE")]):(_vm.data.CESCE)?[_c('v-alert',{staticClass:"ma-0",attrs:{"type":"success","text":""}},[_vm._v("Este cliente está en CESCE")]),_c('v-alert',{staticClass:"ma-0",attrs:{"type":"info","text":""}},[_vm._v("Crédito solicitado: "),_c('b',[_vm._v(_vm._s(_vm.data.creditLimitRequested)+"€")])]),_c('v-alert',{staticClass:"ma-0",attrs:{"type":"info","text":""}},[_vm._v("Crédito concedido: "),_c('b',[_vm._v(_vm._s(_vm.data.creditLimitGranted)+"€")])]),_c('v-alert',{staticClass:"ma-0",attrs:{"type":"info","text":""}},[_vm._v("Cobertura Riesgo Comercial: "),_c('b',[_vm._v(_vm._s(_vm.data.commercialRiskCoverPct)+"%")])])]:_vm._e(),_c('v-spacer'),_c('v-alert',{staticClass:"ma-0",attrs:{"type":_vm.data.CESCE_siniestro ? 'success' : 'error',"text":""}},[_vm._v("Siniestro en CESCE: "),_c('b',[_vm._v(_vm._s(_vm.data.CESCE_siniestro ? "Sí" : "No"))])]),_c('v-btn',{attrs:{"color":"info darken-1","large":""},on:{"click":function($event){$event.stopPropagation();return _vm.siniestroCesce($event)}}},[_vm._v(" Siniestro en CESCE ")])],2),(_vm.$root.acceso('DEV') && !Number(_vm.data.CESCE))?_c('v-row',{staticClass:"align-center"},[_c('v-col',{attrs:{"cols":"12","sm":"3"}},[_c('v-text-field',{attrs:{"label":"Solicitud Crédito €","filled":"","dense":"","hide-details":"auto","rules":[_vm.rules.req]},model:{value:(_vm.creditoSolicitado),callback:function ($$v) {_vm.creditoSolicitado=$$v},expression:"creditoSolicitado"}})],1),_c('v-col',{attrs:{"cols":"auto"}},[_c('v-btn',{attrs:{"disabled":"","loading":_vm.sending,"outlined":"","large":"","color":"secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.enviarCesce($event)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-cog")]),_vm._v("Enviar a CESCE ")],1)],1)],1):_vm._e(),(Number(_vm.data.CESCE))?_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('tarjeta-datos',{attrs:{"titulo":"Datos de CESCE","icon":"cog","datos":[
            { nombre: 'address', valor: _vm.data.address },
            { nombre: 'cancellationDate', valor: _vm.data.cancellationDate },
            { nombre: 'cesceCode', valor: _vm.data.cesceCode },
            { nombre: 'city', valor: _vm.data.city },
            { nombre: 'classificationDate', valor: _vm.data.classificationDate },
            {
              nombre: 'classificationDecisionCode',
              valor: _vm.data.classificationDecisionCode,
            },
            { nombre: 'commentsInd', valor: _vm.data.commentsInd },
            {
              nombre: 'commercialRiskCoverPct',
              valor: _vm.data.commercialRiskCoverPct,
            },
            {
              nombre: 'commercialRiskGroupCode',
              valor: _vm.data.commercialRiskGroupCode,
            },
            { nombre: 'companyName', valor: _vm.data.companyName },
            { nombre: 'countryCode', valor: _vm.data.countryCode },
            { nombre: 'creditLimitGranted', valor: _vm.data.creditLimitGranted },
            {
              nombre: 'creditLimitRequested',
              valor: _vm.data.creditLimitRequested,
            },
            { nombre: 'currencyCode', valor: _vm.data.currencyCode },
            { nombre: 'customerReference', valor: _vm.data.customerReference },
            { nombre: 'effectiveDate', valor: _vm.data.effectiveDate },
            { nombre: 'email', valor: _vm.data.email },
            { nombre: 'endorsementNo', valor: _vm.data.endorsementNo },
            {
              nombre: 'paymentMethodGrantedCode',
              valor: _vm.data.paymentMethodGrantedCode,
            },
            {
              nombre: 'paymentMethodRequestedCode',
              valor: _vm.data.paymentMethodRequestedCode,
            },
            {
              nombre: 'paymentTermsGranted',
              valor: _vm.data.paymentTermsGranted,
            },
            {
              nombre: 'paymentTermsRequested',
              valor: _vm.data.paymentTermsRequested,
            },
            { nombre: 'phoneNo', valor: _vm.data.phoneNo },
            {
              nombre: 'politicalRiskCoverPct',
              valor: _vm.data.politicalRiskCoverPct,
            },
            {
              nombre: 'politicalRiskGroupCode',
              valor: _vm.data.politicalRiskGroupCode,
            },
            { nombre: 'postalCode', valor: _vm.data.postalCode },
            { nombre: 'requestEntryDate', valor: _vm.data.requestEntryDate },
            { nombre: 'state', valor: _vm.data.state },
            { nombre: 'statusCode', valor: _vm.data.statusCode },
            { nombre: 'taxCode', valor: _vm.data.taxCode },
            { nombre: 'validityDate', valor: _vm.data.validityDate },
            { nombre: 'validityReasonCode', valor: _vm.data.validityReasonCode } ]}})],1)],1):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }